import Reveal, { SectionLabel } from "@/components/Reveal";
import { Quote } from "lucide-react";

const QUOTES = [
  {
    text: "It hedged your zone by literally 2 pips, then went straight for 100 pips downside. Perfection.",
    name: "F.",
    tag: "Member · Telegram DM",
    testid: "testimonial-card-1",
  },
  {
    text: "I really admire your humility, man. You make so much money but stay very humble. I'm saving up to come see you soon — I know you will help.",
    name: "S.",
    tag: "Member · Telegram DM",
    testid: "testimonial-card-2",
  },
  {
    text: "Atlas don't lie.",
    name: "Y.",
    tag: "Member · Telegram DM",
    testid: "testimonial-card-3",
  },
];

const SHOTS = [
  { img: "/proof/p3.jpeg", name: "YM 055", testid: "testimonial-shot-ym" },
  { img: "/proof/p4.jpeg", name: "fyuci", testid: "testimonial-shot-fyuci" },
  { img: "/proof/p2.jpeg", name: "Sancho Jadon", testid: "testimonial-shot-sancho" },
  { img: "/proof/p1.jpeg", name: "Mahesh", testid: "testimonial-shot-mahesh" },
  { img: "/proof/p5.jpeg", name: "Gee", testid: "testimonial-shot-gee" },
];

const Testimonials = () => (
  <section id="testimonials" className="relative py-24 lg:py-36 bg-panel/30 border-y border-line/60" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-3xl mb-14 lg:mb-20">
        <Reveal>
          <SectionLabel>Atlas Members</SectionLabel>
          <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-50 leading-tight" data-testid="testimonials-title">
            Testimonials
          </h2>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
        {QUOTES.map((q, i) => (
          <Reveal key={q.testid} delay={i * 0.12}>
            <figure className="h-full flex flex-col border border-line rounded-md p-7 bg-card2/40 hover:border-gold/40 transition-colors duration-500" data-testid={q.testid}>
              <Quote size={20} className="text-gold/70" />
              <blockquote className="mt-5 flex-1 text-sm sm:text-[15px] text-slate-300 leading-relaxed">
                "{q.text}"
              </blockquote>
              <figcaption className="mt-7 pt-5 border-t border-line/60 flex items-center justify-between">
                <p className="font-display font-bold text-sm text-slate-100">{q.name}</p>
                <span className="font-mono text-[10px] tracking-[0.15em] text-gold/70 border border-gold/25 rounded-sm px-2 py-1 uppercase">{q.tag}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-16">
          <p className="font-mono text-[10px] tracking-[0.3em] text-slate-500 uppercase mb-6" data-testid="testimonials-proof-label">
            Straight from the inbox · Shared with permission
          </p>
          <div className="flex gap-5 overflow-x-auto pb-4 mask-fade-x snap-x snap-mandatory" data-testid="testimonials-proof-strip">
            {SHOTS.map((s) => (
              <figure key={s.testid} className="relative shrink-0 snap-center" data-testid={s.testid}>
                <img
                  src={s.img}
                  alt={`Telegram message from Atlas member ${s.name}`}
                  loading="lazy"
                  className="h-[400px] sm:h-[460px] w-auto rounded-lg ring-1 ring-line/80"
                />
                <figcaption className="absolute bottom-3 left-3 bg-ink/80 backdrop-blur border border-gold/30 text-gold font-mono text-[10px] tracking-[0.2em] px-2.5 py-1 rounded-sm uppercase">
                  Atlas Member
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Testimonials;
